// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__tqXFH","image":"Header_image__2tMAT","name":"Header_name__33wBF","info":"Header_info__2z12G","infoRow":"Header_infoRow__OIawX"};